import React, { useEffect, useState } from "react";
import { Button, ButtonGroup } from "react-bootstrap";

// Light/Dark choice for the staff screens (admin panel, lead team portal). Remembered per browser and
// kept apart from the public site's own theme setting ("io-theme").
const STORAGE_KEY = "io-staff-theme";

const readStoredTheme = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
};

const restoreAttribute = (element, name, value) => {
  if (value === null) element.removeAttribute(name);
  else element.setAttribute(name, value);
};

// Applies the theme to <html> while a staff screen is open. It has to sit on the root: modals and
// dropdowns render outside the page's own markup. data-bs-theme switches Bootstrap (and
// styles/staff-dark.css), data-theme the site's colour tokens - which also stops the operating
// system's dark mode from greying out text in the light theme. Both are put back on the way out.
export function useStaffTheme() {
  const [theme, setTheme] = useState(readStoredTheme);

  useEffect(() => {
    const root = document.documentElement;
    const previousBootstrap = root.getAttribute("data-bs-theme");
    const previousSite = root.getAttribute("data-theme");
    root.setAttribute("data-bs-theme", theme);
    root.setAttribute("data-theme", theme);
    return () => {
      restoreAttribute(root, "data-bs-theme", previousBootstrap);
      restoreAttribute(root, "data-theme", previousSite);
    };
  }, [theme]);

  const chooseTheme = (next) => {
    setTheme(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // Private browsing: the switch still works for this visit.
    }
  };

  return [theme, chooseTheme];
}

export default function StaffThemeSwitch({ theme, onChange, size }) {
  return (
    <ButtonGroup size={size} aria-label="Theme">
      <Button variant="outline-secondary" active={theme === "light"} onClick={() => onChange("light")} title="Light theme">
        <i className="bi bi-sun me-1" aria-hidden="true" />
        Light
      </Button>
      <Button variant="outline-secondary" active={theme === "dark"} onClick={() => onChange("dark")} title="Dark theme">
        <i className="bi bi-moon-stars me-1" aria-hidden="true" />
        Dark
      </Button>
    </ButtonGroup>
  );
}
